/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_Tracking_Mode_Lot_DescInputs */

const vi_packaging_material_tracking_mode_lot_desc = /** @type {(inputs: Packaging_Material_Tracking_Mode_Lot_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theo lô (có HSD, mã lô)`)
};

/**

* @param {Packaging_Material_Tracking_Mode_Lot_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_tracking_mode_lot_desc = /** @type {((inputs?: Packaging_Material_Tracking_Mode_Lot_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_Tracking_Mode_Lot_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_tracking_mode_lot_desc(inputs)
});